import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Container, Grid, Stack, Typography, Link } from "@mui/material";
import Iconify from "../../components/Iconify";
import Reveal from "../../components/Reveal";
import { INK, ACCENT } from "../../theme/brand";
import { HIGHLIGHTS } from "./content";

export default function Highlights() {
  return (
    <Box id="funktionen" sx={{ py: { xs: 8, md: 12 }, scrollMarginTop: { xs: 56, md: 72 } }}>
      <Container maxWidth="lg">
        <Stack spacing={1} sx={{ mb: 6, maxWidth: 620 }}>
          <Typography variant="overline" sx={{ color: "primary.main", fontWeight: 700, letterSpacing: 2 }}>
            Funktionen
          </Typography>
          <Typography variant="h3" component="h2" fontWeight={800} letterSpacing="-0.02em">
            Gebaut für den Schulalltag
          </Typography>
          <Typography sx={{ color: "grey.600", fontSize: 17 }}>
            Keine Excel-Listen, keine Zettelwirtschaft – eine Anwendung für
            alles, was neben dem Training anfällt.
          </Typography>
        </Stack>

        <Grid container spacing={3}>
          {HIGHLIGHTS.map((f, i) => (
            <Grid item xs={12} sm={6} key={f.title}>
              <Reveal delay={i * 60}>
                <Box
                  sx={{
                    height: "100%",
                    p: 4,
                    border: "1px solid",
                    borderColor: "grey.200",
                    borderRadius: 3,
                    transition: "border-color 200ms ease, transform 200ms ease, box-shadow 200ms ease",
                    "@media (hover: hover) and (pointer: fine)": {
                      "&:hover": {
                        borderColor: "primary.main",
                        transform: "translateY(-3px)",
                        boxShadow: "0 12px 32px rgba(18,16,31,0.08)",
                      },
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 52,
                      height: 52,
                      borderRadius: 2,
                      bgcolor: INK,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 2.5,
                    }}
                  >
                    <Iconify icon={f.icon} width={26} sx={{ color: ACCENT }} />
                  </Box>
                  <Typography variant="h6" component="h3" fontWeight={700} sx={{ mb: 1 }}>
                    {f.title}
                  </Typography>
                  <Typography sx={{ color: "grey.600" }}>{f.text}</Typography>
                  {f.href && (
                    <Link
                      component={RouterLink}
                      to={f.href}
                      underline="hover"
                      sx={{
                        display: "inline-block",
                        mt: 1.5,
                        fontSize: 14,
                        fontWeight: 700,
                        color: "primary.main",
                      }}
                    >
                      Mehr erfahren →
                    </Link>
                  )}
                </Box>
              </Reveal>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
